import React from 'react';
import {Box, Grid, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import {Utils} from 'commons';
import {EfeLinearProgress} from 'components';
import type {InferPropTypes} from 'commons/types/Types';
import {PageNavStyles} from 'assets/tss/layouts/components';

PageNav.propTypes = {
    activePath: PropTypes.string,
    activeUser: PropTypes.string.isRequired,
    totalSteps: PropTypes.number.isRequired,
    currentStep: PropTypes.number.isRequired,
    showLinearProgress: PropTypes.bool.isRequired,
    loggedIn: PropTypes.bool.isRequired,
};

function PageNav(
    props: InferPropTypes<typeof PageNav.propTypes, typeof PageNavStyles>
) {
    const {
        activePath,
        activeUser,
        totalSteps,
        currentStep,
        showLinearProgress,
        loggedIn,
        classes,
    } = props;
    return (
        <Grid
            container
            direction='row'
            key={Utils.functions.Generate.uniqueID('grid')}>
            <Grid item xs={12}>
                <Box py={4}>
                    <Typography variant='body2' className={classes.clientId}>
                        {loggedIn && `ID de Cliente: ${activeUser}`}
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                {showLinearProgress && (
                    <EfeLinearProgress
                        totalSteps={totalSteps}
                        currentStep={currentStep}
                    />
                )}
            </Grid>
            <Grid item xs={12}>
                <Box pt={4}>
                    <Typography variant={'h3'} color={'inherit'}>
                        {activePath}
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );
}

export default withStyles(PageNavStyles)(PageNav);
